function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PolicyContactSummaryCtrl = function PolicyContactSummaryCtrl($stateParams) {
    _classCallCheck(this, PolicyContactSummaryCtrl);

    this.policyNumber = $stateParams.policyNumber;
    this.totalAccountContacts = null;
    this.pageSize = 5;
};

PolicyContactSummaryCtrl.$inject = ['$stateParams'];

export default PolicyContactSummaryCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/contacts/common/controllers/PolicyContactSummaryCtrl.js
// module id = 1661
// module chunks = 0